import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiRoutes } from 'app/routes/app.routes';
import { HttpService } from '../http/http.service';

@Injectable({
  providedIn: 'root',
})
export class SequenceService {
  private baseUrl = ApiRoutes.api.baseUrl;
  private routes = ApiRoutes.api;
  constructor(private http: HttpClient, private httpService: HttpService) { }

  addSequence(payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.add,
      method: 'post',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  allSequences(pagination?: { page?: number; limit?: number }) {
    const params: any = {};

    if (pagination) {
      if (pagination.page) params.page = pagination.page;
      if (pagination.limit) params.limit = pagination.limit;
    }

    return this.httpService.makeRequest({
      path: this.routes.sequence.retrieve,
      method: 'get',
      options: { params },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  editSequence(id: string, payload: any) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.edit,
      method: 'put',
      options: { id, body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  activeSequence() {
    return this.httpService.makeRequest({
      path: this.routes.sequence.activeSequence,
      method: 'get',
      options: {},
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  deleteSequence(id: string) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.delete,
      method: 'delete',
      options: { id },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  bulkDelete(payload: { ids: number[] }) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.bulkDelete,
      method: 'delete',
      options: { body: payload },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  getSequencesBySemester(semesterId: number) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.retrieve,
      method: 'get',
      options: { params: { semester: semesterId } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }

  setActiveSequence(is_current: boolean, id: string) {
    return this.httpService.makeRequest({
      path: this.routes.sequence.setActiveSequence,
      method: 'post',
      options: { id, body: { is_current } },
      loader: { type: 'spinner' },
      isAuthRoutes: true
    });
  }
}
